module.exports = __webpack_public_path__ + "img/logo.50ad5f09.png";